export default __webpack_public_path__ + "static/media/phone-icon.0bbf4300.svg";